// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_an-0";
export var optionCard = "_an-1";